export const RETRY_FETCH = 'campaignsStatisticsDetails/RETRY_FETCH';
